import { render, staticRenderFns } from "./ArticleOverviewInstitution.vue?vue&type=template&id=43716136&scoped=true"
import script from "./ArticleOverviewInstitution.vue?vue&type=script&lang=js"
export * from "./ArticleOverviewInstitution.vue?vue&type=script&lang=js"
import style0 from "./ArticleOverviewInstitution.vue?vue&type=style&index=0&id=43716136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43716136",
  null
  
)

export default component.exports